/**
 * CSI Skeleton — self-contained shimmer library (injects its own CSS).
 * Works without relying on a separate stylesheet that may not be uploaded.
 */
(() => {
  const STYLE_ID = 'csi-skeleton-style';

  const CSS = `
#${STYLE_ID}-root, .csi-skel { box-sizing: border-box; }
.csi-skel__bone {
  position: relative;
  overflow: hidden !important;
  background-color: #e5e5e5 !important;
  background-image: none !important;
  border: 0 !important;
  display: block;
}
.csi-skel__bone::before {
  content: "" !important;
  position: absolute !important;
  inset: 0 !important;
  z-index: 1 !important;
  transform: translateX(-100%);
  background: linear-gradient(
    90deg,
    rgba(255,255,255,0) 0%,
    rgba(255,255,255,0.15) 35%,
    rgba(255,255,255,0.75) 50%,
    rgba(255,255,255,0.15) 65%,
    rgba(255,255,255,0) 100%
  ) !important;
  animation: csi-skel-wipe 1.25s ease-in-out infinite !important;
  pointer-events: none !important;
}
@keyframes csi-skel-wipe {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}
.csi-skel--product-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 28rem;
  width: 100%;
  pointer-events: none;
}
.csi-skel__media {
  aspect-ratio: 1 / 1;
  width: 100%;
  border-radius: 7px 7px 0 0;
  min-height: 12rem;
}
.csi-skel__body {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  padding: 1.4rem 0.15rem 0.15rem;
  flex: 1 1 auto;
}
.csi-skel__line { height: 1.15rem; border-radius: 0.45rem; }
.csi-skel__line--xs { width: 36%; height: 0.95rem; }
.csi-skel__line--sm { width: 48%; }
.csi-skel__line--md { width: 74%; }
.csi-skel__line--lg { width: 100%; height: 1.45rem; }
.csi-skel__actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.6rem;
  margin-top: auto;
  padding-top: 0.55rem;
}
.csi-skel__btn { height: 3.6rem; border-radius: 0.8rem; }
.csi-skel--predictive {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.85rem 1rem;
}
.csi-skel__thumb {
  width: 5rem;
  height: 5rem;
  border-radius: 0.45rem;
  flex-shrink: 0;
}
.csi-skel__predictive-body {
  flex: 1 1 auto;
  display: grid;
  gap: 0.55rem;
}
.csi-skel--predictive-item { list-style: none; }
`;

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function bone(extraClass = '') {
    return `<div class="csi-skel__bone ${extraClass}"></div>`;
  }

  function productCard() {
    return `
      <li class="grid__item" aria-hidden="true">
        <div class="csi-skel csi-skel--product-card">
          ${bone('csi-skel__media')}
          <div class="csi-skel__body">
            ${bone('csi-skel__line csi-skel__line--xs')}
            ${bone('csi-skel__line csi-skel__line--lg')}
            ${bone('csi-skel__line csi-skel__line--md')}
            ${bone('csi-skel__line csi-skel__line--sm')}
            <div class="csi-skel__actions">
              ${bone('csi-skel__btn')}
              ${bone('csi-skel__btn')}
            </div>
          </div>
        </div>
      </li>
    `;
  }

  function predictiveItem() {
    return `
      <li class="predictive-search__list-item csi-skel--predictive-item" aria-hidden="true">
        <div class="csi-skel csi-skel--predictive">
          ${bone('csi-skel__thumb')}
          <div class="csi-skel__predictive-body">
            ${bone('csi-skel__line csi-skel__line--xs')}
            ${bone('csi-skel__line csi-skel__line--lg')}
            ${bone('csi-skel__line csi-skel__line--sm')}
          </div>
        </div>
      </li>
    `;
  }

  ensureStyles();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureStyles, { once: true });
  }

  window.CsiSkeleton = {
    ensureStyles,
    productCards(count = 12) {
      ensureStyles();
      const n = Math.max(1, Number(count) || 12);
      return Array.from({ length: n }, () => productCard()).join('');
    },
    predictiveList(count = 6) {
      ensureStyles();
      const n = Math.max(1, Number(count) || 6);
      const items = Array.from({ length: n }, () => predictiveItem()).join('');
      return `
        <div id="predictive-search-results" role="listbox" aria-busy="true">
          <div id="predictive-search-results-groups-wrapper" class="predictive-search__results-groups-wrapper predictive-search__results-groups-wrapper--no-suggestions">
            <div class="predictive-search__result-group">
              <div>
                <h2 class="predictive-search__heading text-body caption-with-letter-spacing visually-hidden">Products</h2>
                <ul class="predictive-search__results-list list-unstyled" role="presentation">
                  ${items}
                </ul>
              </div>
            </div>
          </div>
        </div>
      `;
    },
  };
})();
